import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from './input/input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ControlValueAccessorConnector } from './control-value-accessor-connector';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FileInputComponent } from './file-input/file-input.component';
import { InputBaseComponent } from './input-base/input-base.component';
import { MatIconModule } from '@angular/material/icon';
import { SelectInputComponent } from './select-input/select-input.component';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InfoComponent } from '../components/info/info.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  declarations: [
    InputComponent,
    ControlValueAccessorConnector,
    FileInputComponent,
    InputBaseComponent,
    SelectInputComponent,
  ],
  exports: [InputComponent, FileInputComponent, SelectInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    InfoComponent,
    InfiniteScrollModule,
    TranslateModule,
    OverlayModule,
  ],
})
export class InputsModule {}
